import { useState } from "react";
import { faqData } from "@/mocks/homeData";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="text-sm font-semibold text-primary-500 uppercase tracking-wider">
            Support
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-2 mb-4">
            {faqData.headline}
          </h2>
          <p className="text-foreground-700 leading-relaxed">
            {faqData.subheadline}
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
              >
                <span className="font-heading font-semibold text-base md:text-lg text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <span className="shrink-0 w-8 h-8 rounded-full bg-primary-50 flex items-center justify-center">
                  <i
                    className={`ri-${
                      openIndex === index ? "subtract" : "add"
                    }-line text-primary-500 text-lg transition-transform`}
                  />
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <div className="h-px bg-background-200/70 mb-4" />
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}